// 课程
export default [{ // 课程播放
  path: '/coursePlay',
  name: 'coursePlay',
  component: resolve => require(['@/views/course/coursePlay.vue'], resolve),
  meta: {
    isLoginAuthority: true, // 需要登录权限才能访问
    keepAlive: true
  }
}, { // 课程播放
  path: '/coursePlayAttachment',
  name: 'coursePlayAttachment',
  component: resolve => require(['@/views/course/coursePlayAttachment.vue'], resolve),
  meta: {
    isLoginAuthority: true, // 需要登录权限才能访问
  },
}, { // 个人信息
  path: '/courseList',
  name: 'courseList',
  component: resolve => require(['@/views/courseList/courseList.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/course/course.js